/**
 *  Banner
 */
import * as Utils from '../Utils';
import GlobalVars from '../GlobalVars';

/**
 * Top Rotator Banners generator
 *
 * @example <caption>Simple example without options</caption>
 * OCMS.ui.banner({ text:"I am your father." });
 *
 * @example <caption>Advanced example with link and theme</caption>
 * OCMS.ui.banner({
 *     text:"I am your father for xmas.",
 *     link:"http://www.google.com",
 *     theme:"xmas"
 * })
 *
 * @example <caption>Advanced example with link and position</caption>
 * OCMS.ui.banner({
 *     text:"I am your father under the menu.",
 *     link:"http://www.google.com",
 *     position:"menu"
 * })
 *
 * @param {Object} [aoOptions] - Options for the rotator
 * @param {String} [aoOptions.position]
   Optional position to push the Rotator ("top" or "menu"). default : "top".
 * @param {String} [aoOptions.theme]
   Optional theme to skin the Rotator ("generic" or "shipping"). default : "generic".
 * @param {String} [aoOptions.img]
   Optional url of the image to push before the text
   limited size on special themes. default : null.
 * @param {String} [aoOptions.text] - Text to display.
 * @param {String} [aoOptions.text2] - Optional Text2 to display on the second line.
 * @param {String} [aoOptions.link] - Optional link to push on the text. default : null.
 * @param {String} [aoOptions.link2] - Optional link2 to push on the text2. default : null.
 * @param {String} [aoOptions.id] - Optional id for the end span. default : nothing.
 * @param {String} [aoOptions.class] - Optional class for the end span. default : nothing.
 *
 * @param {Function} aoCallback - optional Callback
*/
function create(aoOptions, aoCallback) {
  if (Utils.isCheckout()) {
    return;
  }

  const bannerClass = 'm-banner';
  const headerId = 'header';

  const defaultOptions = {
    position: 'top',
    theme: 'generic',
    img: null,
    text: null,
    text2: null,
    textMobile: null,
    link: null,
    link2: null,
    linkMobile: null,
    id: null,
    class: null,
  };

  function getItemContent(text, link, theme, img) {
    const icon = theme != null && theme !== defaultOptions.theme ? `<i class="${bannerClass}__icon a-icon a-icon--${theme}"></i>` : '';
    const image = img != null ? `<img class="${bannerClass}__img" src="${img}">` : '';
    let content = '';

    if (link !== null) {
      content = `<a href="${link}" class="a-text--semi-bold">${image}${text}</a>`;
    } else {
      content = `<span class="a-text--semi-bold">${image}${text}</span>`;
    }

    return `<li class="m-banner__item">${icon}${content}</li>`;
  }

  function getContent(opt) {
    let content = '';

    // MOBILE content
    if (GlobalVars.IsMobile) {
      if (opt.textMobile !== null) {
        content = getItemContent(opt.textMobile, opt.linkMobile, opt.theme, opt.img);
      }
      return content;
    }

    // DESKTOP content
    content = getItemContent(opt.text, opt.link, opt.theme, opt.img);

    if (opt.text2 !== null) {
      const content2 = getItemContent(opt.text2, opt.link2);
      content = `${content}${content2}`;
    }

    return content;
  }

  function createBanner() {
    // merging the aoOptions with the default options
    const opt = Object.assign(defaultOptions, aoOptions);

    // MOBILE LIGHT VERSION
    if (GlobalVars.IsMobile && opt.textMobile == null) {
      // optional callback trigger
      if (typeof aoCallback === 'function') {
        aoCallback();
      }
      return false;
    }

    const id = opt.id != null ? ` id="${opt.id}"` : '';
    const content = getContent(opt);
    let classCss = `${bannerClass} ${bannerClass}--${opt.position}`;
    if (opt.class != null) {
      classCss = `${classCss} ${opt.class}`;
    }

    // div creation with content and pushing the right classes on the div following the options
    const $banner = $(`<div${id} class="${classCss}"><ul class="${bannerClass}__list">${content}</ul></div>`);

    // removing the previous banner if already existing in the position requested
    const $oldBanners = $(`.${bannerClass}--${opt.position}`);
    if ($oldBanners.length > 0) {
      $oldBanners.remove();
    }

    // On mobile, always under the header
    if (GlobalVars.IsMobile) {
      opt.position = 'menu';
    }

    // finding the target container for the position
    switch (opt.position) {
      case 'top':
      case 'menu':
      default: {
        $(`#${headerId}`).after($banner);
        break;
      }
    }

    // optional callback trigger
    if (typeof aoCallback === 'function') {
      aoCallback();
    }

    return true;
  }

  createBanner();
}

export {
  create,
};

export default create;



// WEBPACK FOOTER //
// ./js/common/molecule/banner.js